import styled from "@emotion/styled"

const TechOneCategories = styled.div`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    display: contents;
  }
`

export default TechOneCategories
